/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ComparisonOperator {
  EqualTo = 1,
  NotEqualTo = 2,
  GreaterThan = 3,
  LessThan = 4,
  GreaterThanOrEqual = 5,
  LessThanOrEqual = 6,
  Contains = 7,
  NotContains = 8,
  StartsWith = 9,
  EndsWith = 10
}
